import { 
  HiDocument, 
  HiDocumentText, 
  HiDocumentDuplicate,
  HiArrowDownTray,
  HiTrash,
  HiPencil,
  HiMagnifyingGlass,
  HiCheckCircle,
  HiXCircle,
  HiExclamationCircle,
  HiInformationCircle,
  HiArrowUpTray,
  HiFolder,
  HiXMark,
  HiArrowPath,
} from 'react-icons/hi2';

// Map document types to icons
const documentTypeIcons = {
  'Articles of Organization': HiDocumentText,
  'Operating Agreement': HiDocumentDuplicate,
  'EIN Confirmation': HiDocument,
  'Annual Report': HiFolder,
  'Tax Filing': HiDocumentText,
  'Compliance Document': HiDocument,
  'Other': HiDocument,
};

// Map action types to icons
const actionIcons = {
  download: HiArrowDownTray,
  delete: HiTrash,
  edit: HiPencil,
  search: HiMagnifyingGlass,
  upload: HiArrowUpTray,
  refresh: HiArrowPath,
};

// Map status types to icons
const statusIcons = {
  success: HiCheckCircle,
  error: HiXCircle,
  warning: HiExclamationCircle,
  info: HiInformationCircle,
  close: HiXMark,
};

function Icon({ name, type = 'action', size = 20, color = null, className = '', style = {} }) {
  let IconComponent = null;

  if (type === 'document' && documentTypeIcons[name]) {
    IconComponent = documentTypeIcons[name];
  } else if (type === 'action' && actionIcons[name]) {
    IconComponent = actionIcons[name];
  } else if (type === 'status' && statusIcons[name]) {
    IconComponent = statusIcons[name];
  } else {
    // Default fallback
    IconComponent = HiDocument;
  }

  if (!IconComponent) {
    return null;
  }

  return (
    <IconComponent
      size={size}
      color={color}
      className={className}
      style={style}
      aria-hidden="true"
    />
  );
}

export default Icon;

